import FormSelect from '@/agilis/components/Form/FormSelect/FormSelect.vue'
import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

export default {
  name: 'FormSelectMultiple',

  props: {
    fieldConfig: Object,
    value: [String, Object, Array]
  },

  components: {
    FormSelect
  },

  data: () => ({
    innerValue: []
  }),

  created () {
    this.setConfigDefaults()
    this.innerValue = this.mapItemDTOForEdit(this.value)
  },

  watch: {
    innerValue (newValue, oldValue) { // propagating v-model to the wrapped input (2/2)
      let valueIsChanged = false
      if (Array.isArray(newValue) && Array.isArray(oldValue)) {
        valueIsChanged = newValue.length !== oldValue.length
      } else if (typeof newValue === 'string' && typeof oldValue === 'string') {
        valueIsChanged = newValue !== oldValue
      } else {
        valueIsChanged = true
      }
      if (valueIsChanged) {
        this.$emit('input', this.mapItemDTOForSave(newValue))
      }
    },
    value (newValue) {
      if (typeof newValue !== 'string') {
        this.innerValue = newValue
      }
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId'
    }),

    computedFieldConfig () {
      return Object.assign({}, this.fieldConfig, { filter: this.filterFn })
    }
  },

  methods: {
    setConfigDefaults () {
      // default item-text and item-value
      this.fieldConfig.itemText = this.fieldConfig.itemText ? this.fieldConfig.itemText : 'text'
      this.fieldConfig.itemValue = this.fieldConfig.itemValue ? this.fieldConfig.itemValue : 'id'
      // default output value
      this.fieldConfig.outValue = this.fieldConfig.outValue ? this.fieldConfig.outValue : this.fieldConfig.itemValue
    },

    mapItemDTOForEdit (multiValueString = '') {
      let multiValue = multiValueString
      if (!Array.isArray(multiValue)) {
        multiValue = []
        if (multiValueString) {
          const matches = multiValueString.split(',')
          for (const match of matches) {
            const m = match.trim()
            multiValue.push(m)
          }
        }
      }
      return multiValue
    },

    mapItemDTOForSave (multiValue = []) {
      if (Array.isArray(multiValue) && multiValue.length > 0) {
        let transformedMultiValue = multiValue.map(value => {
          if (typeof value === 'object') {
            let outItem = {}
            const transformJson = {}
            const transformExpr = this.fieldConfig.outValueExpr || this.fieldConfig.itemValue
            transformJson[this.fieldConfig.outValue] = transformExpr
            Configuration.datatable.jsonTransform(value, transformJson, outItem)
            return outItem[this.fieldConfig.outValue]
          } else {
            return value
          }
        })
        if (typeof transformedMultiValue[0] === 'object') {
          return transformedMultiValue
        }
        return transformedMultiValue.join(',')
      }
      return null
    }
  }
}
